import {ListViewUIPreferenceJSON,
        ListViewUIPreferenceModel,
        ListViewUIPreferenceFactory,
        ApplicationUIPreferenceJSON,
        ApplicationUIPreferenceModel,
        ApplicationUIPreferenceFactory,
        TabUIPreferenceJSON,
        TabUIPreferenceModel,
        TabUIPreferenceFactory,
        SortDirectionType,
        SortOrderModel,
        BarChartUIPreferenceModel} from './modelsUserConfiguration';
import {DashboardScreenElementJSON,
        DashboardScreenElementModel,
        DashboardScreenElementFactory,
        SearchScreenElementJSON,
        SearchScreenElementModel,
        SearchScreenElementFactory} from './modelsScreenElements';


export interface BaseJSON {
  Id_sys: string;
  Uuid_sys: string;
  ApiName_sys: string;
  Label_sys: string;
}

export class BaseModel {
  Id_sys: string;
  Uuid_sys: string;
  ApiName_sys: string;
  Label_sys: string;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
  ) {

    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.ApiName_sys = ApiName_sys;
    this.Label_sys = Label_sys;
  }
}


export class BaseFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: BaseJSON): BaseModel {
    return new BaseModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: BaseModel): BaseJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export type IconType = 'MuiIcon' | 'AssetIcon'

export interface IconJSON {
  Type_sys: IconType;
  Name_sys: string;
  Colour_sys: string;
  BackgroundColour_sys: string;
}

export class IconModel {

  Type_sys: IconType;
  Name_sys: string;
  Colour_sys: string;
  BackgroundColour_sys: string;

  constructor(
    Type_sys: IconType,
    Name_sys: string,
    Colour_sys: string,
    BackgroundColour_sys: string
  ) {
    this.Type_sys = Type_sys;
    this.Name_sys = Name_sys;
    this.Colour_sys = Colour_sys;
    this.BackgroundColour_sys = BackgroundColour_sys;
  }
}

export class IconFactory {
  fromJSON(json: IconJSON): IconModel {
    return new IconModel(
      json.Type_sys,
      json.Name_sys,
      json.Colour_sys,
      json.BackgroundColour_sys
    );
  }
  toJSON(model: IconModel): IconJSON {
    return {
      Type_sys: model.Type_sys,
      Name_sys: model.Name_sys,
      Colour_sys: model.Colour_sys,
      BackgroundColour_sys: model.BackgroundColour_sys
    };
  }
  deepcopy(model: IconModel): IconModel {
    return new IconModel(
      model.Type_sys,
      model.Name_sys,
      model.Colour_sys,
      model.BackgroundColour_sys
    );
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface BackendImageJSON {
  url: string;
  type: string;
  alt: string;
  width: number;
  height: number;
}

export class BackendImageModel {

  url: string;
  type: string;
  alt: string;
  width: number;
  height: number;

  constructor(
    url: string,
    type: string,
    alt: string,
    width: number,
    height: number
  ) {
    this.url = url;
    this.type = type;
    this.alt = alt;
    this.width = width;
    this.height = height;
  }
}

export class BackendImageFactory {
  fromJSON(json: BackendImageJSON): BackendImageModel {
    return new BackendImageModel(
      json.url,
      json.type,
      json.alt,
      json.width,
      json.height
    );
  }
  toJSON(model: BackendImageModel): BackendImageJSON {
    return {
      url: model.url,
      type: model.type,
      alt: model.alt,
      width: model.width,
      height: model.height
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export type DefaultValueType = {
  type: string | null;
  value: string | null;
  context: any;
}

export interface FieldMetadataJSON extends BaseJSON {
  Type_sys: string;
  Required_sys: boolean;
  HelpText_sys: string;
  Length_sys: number;
  VisibleLines_sys: number;
  DefaultValue_sys: DefaultValueType;
  MaskChar_sys: string;
  MaskType_sys: string;
  PicklistValues_sys: any;
  Precision_sys: number;
  Scale_sys: number;
  ReturnType_sys: string;
  ReferencedObject_sys: any;

}

export class FieldMetadataModel extends BaseModel {

  Type_sys: string;
  Required_sys: boolean;
  HelpText_sys: string;
  Length_sys: number;

  VisibleLines_sys: number;
  DefaultValue_sys: DefaultValueType;
  MaskChar_sys: string;
  MaskType_sys: string;
  PicklistValues_sys: any;
  Precision_sys: number;
  Scale_sys: number;
  ReturnType_sys: string;
  ReferencedObject_sys: any;

  constructor(
    Id_sys: string = '',
    Uuid_sys: string = '',
    ApiName_sys: string = '',
    Label_sys: string = '',
    Type_sys: string = '',
    Required_sys: boolean = false,
    HelpText_sys: string = '',
    Length_sys: number = 0,
    VisibleLines_sys: number = 0,
    DefaultValue_sys: DefaultValueType = {type: null,
                                          value: null,
                                          context: {}},
    MaskChar_sys: string = '',
    MaskType_sys: string = '',
    PicklistValues_sys: any = {},
    Precision_sys: number = 0,
    Scale_sys: number = 0,
    ReturnType_sys = '',
    ReferencedObject_sys: any = {}
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Type_sys = Type_sys;
    this.Required_sys = Required_sys;
    this.HelpText_sys = HelpText_sys;
    this.Length_sys = Length_sys;
    this.VisibleLines_sys = VisibleLines_sys;
    this.DefaultValue_sys = DefaultValue_sys;
    this.MaskChar_sys = MaskChar_sys;
    this.MaskType_sys = MaskType_sys;
    this.PicklistValues_sys = PicklistValues_sys;
    this.Precision_sys = Precision_sys;
    this.Scale_sys = Scale_sys;
    this.ReturnType_sys = ReturnType_sys;
    this.ReferencedObject_sys = ReferencedObject_sys;
  }
}

export class FieldMetadataFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: FieldMetadataJSON): FieldMetadataModel {
    return new FieldMetadataModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Type_sys,
      json.Required_sys,
      json.HelpText_sys,
      json.Length_sys,
      json.VisibleLines_sys,
      json.DefaultValue_sys,
      json.MaskChar_sys,
      json.MaskType_sys,
      json.PicklistValues_sys,
      json.Precision_sys,
      json.Scale_sys,
      json.ReturnType_sys,
      json.ReferencedObject_sys
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: FieldMetadataModel): FieldMetadataJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Type_sys: model.Type_sys,
      Required_sys: model.Required_sys,
      HelpText_sys: model.HelpText_sys,
      Length_sys: model.Length_sys,
      VisibleLines_sys: model.VisibleLines_sys,
      DefaultValue_sys: model.DefaultValue_sys,
      MaskChar_sys: model.MaskChar_sys,
      MaskType_sys: model.MaskType_sys,
      PicklistValues_sys: model.PicklistValues_sys,
      Precision_sys: model.Precision_sys,
      Scale_sys: model.Scale_sys,
      ReturnType_sys: model.ReturnType_sys,
      ReferencedObject_sys: model.ReferencedObject_sys
    };
  }

  /**
   *
   * @param model
   */
  deepCopy(model: FieldMetadataModel): FieldMetadataModel {
    return new FieldMetadataModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.Type_sys,
      model.Required_sys,
      model.HelpText_sys,
      model.Length_sys,
      model.VisibleLines_sys,
      model.DefaultValue_sys,
      model.MaskChar_sys,
      model.MaskType_sys,
      model.PicklistValues_sys,
      model.Precision_sys,
      model.Scale_sys,
      model.ReturnType_sys,
      model.ReferencedObject_sys
    );
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface FieldJSON {
  fieldValue: any;
  fieldName: string;
  fieldChanged: boolean;
  fieldType: string;
}

export class FieldModel {

  fieldValue: any;
  fieldName: string;
  fieldChanged: boolean;
  fieldType: string;

  constructor(
    fieldValue: any,
    fieldName: string,
    fieldChanged: boolean,
    fieldType: string
  ) {

    this.fieldValue = fieldValue;
    this.fieldName = fieldName;
    this.fieldChanged = fieldChanged;
    this.fieldType = fieldType;
  }
}

export class FieldFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: FieldJSON): FieldModel {
    return new FieldModel(
      json.fieldValue,
      json.fieldName,
      json.fieldChanged,
      json.fieldType
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: FieldModel): FieldJSON {
    return {
      fieldValue: model.fieldValue,
      fieldName: model.fieldName,
      fieldChanged: model.fieldChanged,
      fieldType: model.fieldType
    };
  }

  /**
   *
   * @param model
   */
  deepCopy(model: FieldModel): FieldModel {
    return new FieldModel(
      model.fieldValue,
      model.fieldName,
      model.fieldChanged,
      model.fieldType
    );
  }

  /**
   *
   * @param fieldMetadata
   */

  initFromMetadata(fieldMetadata: FieldMetadataModel): FieldModel {

    const getDefaultValue = (defaultValue: DefaultValueType, fieldType: string) => {
      /*****NEEDS TO BE REVIEWED ****/

      if(fieldType === 'CharField'){
        return defaultValue.value
      }
      else if(fieldType === 'TextField'){
        return defaultValue.value
      }
      else if(fieldType === 'BooleanField' &&
              defaultValue.value === 'True'){
                return true
      }
      else if(fieldType === 'BooleanField'){
                return false;
      }
      else if(fieldType === 'DateField' &&
              defaultValue.value !== null){
        //ToDo: handle functions here
        return new Date()
      }
      else if(fieldType === 'DateTimeField' &&
              defaultValue.value !== null){
        //ToDo: handle functions here
        return new Date()
//        return new Date(defaultValue.value);
      }
      else if(fieldType === 'SlugField'){
        return null
      }
      else if(fieldType === 'JSONField'){
        //ToDo: handle functions here
        return defaultValue.value
      }
      else if(fieldType === 'IntegerField' &&
              defaultValue.value !== null){
        return parseInt(defaultValue.value);
      }
      else if(fieldType === 'URLField'){
        return defaultValue.value;
      }
      else if(fieldType === 'DecimalField' &&
              defaultValue.value !== null){
        return parseFloat(defaultValue.value);
      }
      else if(fieldType === 'EmailField'){
        return defaultValue.value;
      }
      else if(fieldType === 'PhoneField'){
        return defaultValue.value;
      }
      else if(fieldType === 'ForeignKey'){
        return null
      }
      else if(fieldType === 'EncryptedCharField'){
        return defaultValue.value
      }
      else if(fieldType === 'BigAutoField' &&
              defaultValue.value !== null){
        return parseInt(defaultValue.value)
      }
      else if(fieldType === 'UUIDField'){
        return defaultValue.value
      }
      return null
    }

    const fieldName = fieldMetadata.ApiName_sys
    const fieldChanged = false
    const fieldType = fieldMetadata.Type_sys
    const fieldValue = getDefaultValue(fieldMetadata.DefaultValue_sys, fieldType)

    return new FieldModel(
      fieldValue,
      fieldName,
      fieldChanged,
      fieldType
    );
  }

}

//************************************************//
//************************************************//
//************************************************//

export interface FlowJSON extends BaseJSON {
}

export class FlowModel extends BaseModel {

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);
  }
}

export class FlowFactory {

  fromJSON(json: FlowJSON): FlowModel {
    return new FlowModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys
    );
  }
  toJSON(model: FlowModel): FlowJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys
    };
  }

  deepCopy(model: FlowModel): FlowModel {
    return new FlowModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys
    );
  }

}

//************************************************//
//************************************************//
//************************************************//

export interface ActionJSON extends BaseJSON {
  Type_sys: string;
  EndpointUrl_sys: string;
  OnSuccess_sys: any;
  OnError_sys: any;
  ReferencedIcon_sys: IconJSON | null;
  ReferencedFlow_sys: FlowJSON | null;
}

export class ActionModel extends BaseModel {

  Type_sys: string;
  EndpointUrl_sys: string;
  OnSuccess_sys: any;
  OnError_sys: any;
  ReferencedIcon_sys: IconModel | null;
  ReferencedFlow_sys: FlowModel | null;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Type_sys: string,
    EndpointUrl_sys: string,
    OnSuccess_sys: any,
    OnError_sys: any,
    ReferencedIcon_sys: IconModel | null,
    ReferencedFlow_sys: FlowModel | null
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Type_sys = Type_sys;
    this.EndpointUrl_sys = EndpointUrl_sys;
    this.OnSuccess_sys = OnSuccess_sys;
    this.OnError_sys = OnError_sys;
    this.ReferencedIcon_sys = ReferencedIcon_sys;
    this.ReferencedFlow_sys = ReferencedFlow_sys;

  }
}


export class ActionFactory {
  fromJSON(json: ActionJSON): ActionModel {
    let thisFlow = null;
    if(json.ReferencedFlow_sys) thisFlow = new FlowFactory().fromJSON(json.ReferencedFlow_sys)
    let thisIcon = null
    if(json.ReferencedIcon_sys) thisIcon = new IconFactory().fromJSON(json.ReferencedIcon_sys)
    return new ActionModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Type_sys,
      json.EndpointUrl_sys,
      json.OnSuccess_sys,
      json.OnError_sys,
      thisIcon,
      thisFlow
    );
  }
  toJSON(model: ActionModel): ActionJSON {
    let thisFlow = null;
    if(model.ReferencedFlow_sys) thisFlow = new FlowFactory().toJSON(model.ReferencedFlow_sys)
    let thisIcon = null
    if(model.ReferencedIcon_sys) thisIcon = new IconFactory().toJSON(model.ReferencedIcon_sys)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Type_sys: model.Type_sys,
      EndpointUrl_sys: model.EndpointUrl_sys,
      OnSuccess_sys: model.OnSuccess_sys,
      OnError_sys: model.OnError_sys,
      ReferencedIcon_sys: thisIcon,
      ReferencedFlow_sys: thisFlow
    };
  }

  deepCopy(model: ActionModel): ActionModel {
    return new ActionModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.Type_sys,
      model.EndpointUrl_sys,
      model.OnSuccess_sys,
      model.OnError_sys,
      model.ReferencedIcon_sys,
      model.ReferencedFlow_sys
    );
  }

}

//************************************************//
//************************************************//
//************************************************//

export type FileInfoType = {
  filename: string;
  url: string | null;
  mimetype: string | null;
}

export class FileModel {
  fieldName: string;
  fileName: string;
  file: File;

  constructor(
    fieldName: string,
    fileName: string,
    file: File
  ) {
    this.fieldName = fieldName;
    this.fileName = fileName;
    this.file = file;

  }
}

export interface RecordJSON {
  fields: any;
  access_rights: string[];
  information_type?: string;
  object_api_name?: string;
  parent_layout_combined_related_list_item_uuid?: string;
}

export class RecordModel {
  fields: any;
  accessRights: string[];
  informationType?: string;
  objectApiName?: string;
  parentLayoutCombinedRelatedListItemUuid?: string;

  constructor(
    fields: any,
    accessRights: string[],
    informationType?: string,
    objectApiName?: string,
    parentLayoutCombinedRelatedListItemUuid?: string
  ) {
    this.fields = fields;
    this.accessRights = accessRights;
    this.informationType = informationType;
    this.objectApiName = objectApiName;
    this.parentLayoutCombinedRelatedListItemUuid = parentLayoutCombinedRelatedListItemUuid;
  }

}


export class RecordFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: RecordJSON): RecordModel {

    const fields=Object.create({})
    const keys = Object.keys(json.fields)
    keys.map((thisKey) => {
         const thisField = new FieldFactory().fromJSON(json.fields[thisKey]);
         fields[thisKey]=thisField
    })

    const accessRights: string[] = json.access_rights.map((accessRight) => accessRight);

    return new RecordModel(
      fields,
      accessRights,
      json?.information_type,
      json?.object_api_name,
      json?.parent_layout_combined_related_list_item_uuid
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: RecordModel): RecordJSON {

    const fields=Object.create({})
    const keys = Object.keys(model.fields)
    keys.map((thisKey) => {
      const thisField = new FieldFactory().toJSON(model.fields[thisKey]);
      fields[thisKey]=thisField
    })

    const accessRights = model.accessRights;

    return {
      fields: fields,
      access_rights: accessRights,
      information_type: model?.informationType,
      object_api_name: model?.objectApiName,
      parent_layout_combined_related_list_item_uuid: model?.parentLayoutCombinedRelatedListItemUuid
    };
  }

  /**
   *
   * @param model
   */
  getFILES(model: RecordModel): any {

    const files: FileModel[] =[];
    const keys = Object.keys(model.fields)
    keys.map((thisKey) => {
        const thisField = model.fields[thisKey]
        if(thisField.file){
          files.push(new FileModel(thisField.fieldName,
                                   thisField.fieldValue,
                                   thisField.file))
        }
    })
    return files
  }


  /**
   *
   * @param model
   */
  deepCopy(model: RecordModel): RecordModel {

    const fields=Object.create({})
    const keys = Object.keys(model.fields)
    keys.map((thisKey) => {
      const thisField = new FieldFactory().deepCopy(model.fields[thisKey]);
      fields[thisKey]=thisField
    })

    const accessRights = model.accessRights.map((accessRight) => accessRight);


    return new RecordModel(
       fields,
       accessRights,
       model?.informationType,
       model?.objectApiName,
       model?.parentLayoutCombinedRelatedListItemUuid
     );
  }

  /**
   *
   * @param fieldMetadata
   */
  initFromMetadata(fieldMetadata: FieldMetadataModel[], recordType: RecordTypeModel | null): RecordModel {

    const fields=Object.create({})

    fieldMetadata.map((thisFieldMetadata) => {
      const thisField = new FieldFactory().initFromMetadata(thisFieldMetadata);
      const key = thisFieldMetadata.ApiName_sys;
      fields[key]=thisField
    })

    //create record type field
    if(recordType){
      const thisField = new FieldModel({"Id_sys": recordType.Id_sys, "Uuid_sys": recordType.Uuid_sys}, 'ReferencedRecordType_sys', true, 'ForeignKey')
      fields['ReferencedRecordType_sys'] = thisField
    }


    const accessRights: string[] = [];

    return new RecordModel(
       fields,
       accessRights
     );
  }

}

//************************************************//
//************************************************//
//************************************************//

export interface MergedRecordJSON{
  [fieldApiName: string]: string;
}

export class MergedRecordModel {
  //this is a mapping of field api name to uuid
  [fieldApiName: string]: string;

  constructor(
    fields: Record<string, string> = {}
  ) {
    Object.assign(this, fields);
  }

}

export class MergedRecordFactory {

  fromJSON(json: MergedRecordJSON): MergedRecordModel {

    for(const [key, value] of Object.entries(json)) {
      if(typeof value !== 'string'){
        throw new Error ('Error in MergedRecordFactory: Invalid value for field')
      }
    }

    return new MergedRecordModel({...json})

  }

  toJSON(model: MergedRecordModel): MergedRecordJSON {
    const result: Record<string, string> = {}
    const keys = Object.keys(model);

    keys.map((thisKey) => {
      const value = model[thisKey];
      result[thisKey]=value
    })

    return result
  }

  init(): MergedRecordModel{
    return new MergedRecordModel({})
  }

  }



//************************************************//
//************************************************//
//************************************************//

//define lookupfield explicitly

export class LookupFieldModel {
  Id_sys: string;
  Uuid_sys: string;
  lookup_display_value: string;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    lookup_display_value: string
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.lookup_display_value = lookup_display_value;
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface LayoutFieldJSON {
  Uuid_sys: string;
  ApiName_sys: string;
  PositionX_sys: number;
  PositionY_sys: number;
  Width_sys: number;
  AccessSetting_sys: string;
  ReferencedField_sys: FieldMetadataJSON;
}

export class LayoutFieldModel {
  Uuid_sys: string;
  ApiName_sys: string;
  PositionX_sys: number;
  PositionY_sys: number;
  Width_sys: number;
  AccessSetting_sys: string;
  ReferencedField_sys: FieldMetadataModel;

  constructor(
    Uuid_sys: string = '',
    ApiName_sys: string = '',
    PositionX_sys: number = 0,
    PositionY_sys: number = 0,
    Width_sys: number = 0,
    AccessSetting_sys: string = '',
    ReferencedField_sys: FieldMetadataModel = new FieldMetadataModel()
  ) {
    this.Uuid_sys = Uuid_sys;
    this.ApiName_sys = ApiName_sys;
    this.PositionX_sys = PositionX_sys;
    this.PositionY_sys = PositionY_sys;
    this.Width_sys = Width_sys;
    this.AccessSetting_sys = AccessSetting_sys;
    this.ReferencedField_sys = ReferencedField_sys;
  }
}


export class LayoutFieldFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutFieldJSON): LayoutFieldModel {

    const field = new FieldMetadataFactory().fromJSON(json.ReferencedField_sys);

    return new LayoutFieldModel(
      json.Uuid_sys,
      json.ApiName_sys,
      json.PositionX_sys,
      json.PositionY_sys,
      json.Width_sys,
      json.AccessSetting_sys,
      field
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutFieldModel): LayoutFieldJSON {

    const field = new FieldMetadataFactory().toJSON(model.ReferencedField_sys);

    return {
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      PositionX_sys: model.PositionX_sys,
      PositionY_sys: model.PositionY_sys,
      Width_sys: model.Width_sys,
      AccessSetting_sys: model.AccessSetting_sys,
      ReferencedField_sys: field
    };
  }

  /**
   *
   * @param model
   */
  deepCopy(model: LayoutFieldModel): LayoutFieldModel {

    const field = new FieldMetadataFactory().deepCopy(model.ReferencedField_sys);

    return new LayoutFieldModel(
      model.Uuid_sys,
      model.ApiName_sys,
      model.PositionX_sys,
      model.PositionY_sys,
      model.Width_sys,
      model.AccessSetting_sys,
      field
    );
  }
}
//************************************************//
//************************************************//
//************************************************//

export interface LayoutRelatedListColumnJSON extends BaseJSON {
  ReferencedField_sys: FieldMetadataJSON;
}

export class LayoutRelatedListColumnModel extends BaseModel {

  ReferencedField_sys: FieldMetadataModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedField_sys: FieldMetadataModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedField_sys = ReferencedField_sys;
  }
}

export class LayoutRelatedListColumnFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutRelatedListColumnJSON): LayoutRelatedListColumnModel {

    const ReferencedField_sys = new FieldMetadataFactory().fromJSON(json.ReferencedField_sys);

    return new LayoutRelatedListColumnModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      ReferencedField_sys
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutRelatedListColumnModel): LayoutRelatedListColumnJSON {
    const ReferencedField_sys = new FieldMetadataFactory().toJSON(model.ReferencedField_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedField_sys: ReferencedField_sys
    };
  }

  /**
   *
   * @param model
   */
  deepCopy(model: LayoutRelatedListColumnModel): LayoutRelatedListColumnModel {

    const ReferencedField_sys = new FieldMetadataFactory().deepCopy(model.ReferencedField_sys);

    return new LayoutRelatedListColumnModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      ReferencedField_sys
    );
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface LayoutRelatedListButtonJSON extends BaseJSON {
  ReferencedAction_sys: ActionJSON;
}

export class LayoutRelatedListButtonModel extends BaseModel {

  ReferencedAction_sys: ActionModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedAction_sys: ActionModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedAction_sys = ReferencedAction_sys;
  }
}

export class LayoutRelatedListButtonFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutRelatedListButtonJSON): LayoutRelatedListButtonModel {

    const ReferencedAction_sys = new ActionFactory().fromJSON(json.ReferencedAction_sys);

    return new LayoutRelatedListButtonModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      ReferencedAction_sys
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutRelatedListButtonModel): LayoutRelatedListButtonJSON {
    const ReferencedAction_sys = new ActionFactory().toJSON(model.ReferencedAction_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedAction_sys: ReferencedAction_sys
    };
  }

  /**
   *
   * @param model
   */
  deepCopy(model: LayoutRelatedListButtonModel): LayoutRelatedListButtonModel {

    const ReferencedAction_sys = new ActionFactory().deepCopy(model.ReferencedAction_sys);

    return new LayoutRelatedListButtonModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      ReferencedAction_sys
    );
  }
}

//************************************************//
//************************************************//
//************************************************//


export interface LayoutRelatedListJSON extends BaseJSON {
  columns: LayoutRelatedListColumnJSON[];
  buttons: LayoutRelatedListButtonJSON[];
  ReferencedObject_sys: ObjectJSON;
}

export class LayoutRelatedListModel extends BaseModel {

  columns: LayoutRelatedListColumnModel[];
  buttons: LayoutRelatedListButtonModel[];
  ReferencedObject_sys: ObjectModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedObject_sys: ObjectModel,
    columns: LayoutRelatedListColumnModel[],
    buttons: LayoutRelatedListButtonModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedObject_sys = ReferencedObject_sys;
    this.columns = columns;
    this.buttons = buttons;
  }
}

export class LayoutRelatedListFactory {
  /**
   *
   * @param json
   */


  fromJSON(json: LayoutRelatedListJSON): LayoutRelatedListModel {

    let columns : LayoutRelatedListColumnModel[] = [];
    if(json.columns !== undefined){
      columns = json.columns.map((column) => new LayoutRelatedListColumnFactory().fromJSON(column))
    }

    let buttons : LayoutRelatedListButtonModel[] = [];
    if(json.buttons !== undefined){
      buttons = json.buttons.map((button) => new LayoutRelatedListButtonFactory().fromJSON(button))
    }

    const ReferencedObject_sys = new ObjectFactory().fromJSON(json.ReferencedObject_sys);

    return new LayoutRelatedListModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      ReferencedObject_sys,
      columns,
      buttons
    );
  }
  /**
   *
   * @param model
   */

  toJSON(model: LayoutRelatedListModel): LayoutRelatedListJSON {
    const columns = model.columns.map((column) => new LayoutRelatedListColumnFactory().toJSON(column))
    const buttons = model.buttons.map((button) => new LayoutRelatedListButtonFactory().toJSON(button))
    const ReferencedObject_sys = new ObjectFactory().toJSON(model.ReferencedObject_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedObject_sys: ReferencedObject_sys,
      columns: columns,
      buttons: buttons
    };
  }
}



//************************************************//
//************************************************//
//************************************************//


export interface LayoutCombinedRelatedListMappingJSON extends BaseJSON {
  ReferencedField_sys: FieldMetadataJSON;
  ReferencedLayoutCombinedRelatedListItem_sys: {Uuid_sys: string};
}

export class LayoutCombinedRelatedListMappingModel extends BaseModel {

  ReferencedField_sys: FieldMetadataJSON;
  ReferencedLayoutCombinedRelatedListItem_sys: {Uuid_sys: string};

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedField_sys: FieldMetadataJSON,
    ReferencedLayoutCombinedRelatedListItem_sys: {Uuid_sys: string}
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedField_sys = ReferencedField_sys;
    this.ReferencedLayoutCombinedRelatedListItem_sys = ReferencedLayoutCombinedRelatedListItem_sys;

  }
}

export class LayoutCombinedRelatedListMappingFactory {

  fromJSON(json: LayoutCombinedRelatedListMappingJSON): LayoutCombinedRelatedListMappingModel {

    const thisField = new FieldMetadataFactory().fromJSON(json.ReferencedField_sys);

    return new LayoutCombinedRelatedListMappingModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      'foo',
      thisField,
      json.ReferencedLayoutCombinedRelatedListItem_sys

    );
  }

  toJSON(model: LayoutCombinedRelatedListMappingModel): LayoutCombinedRelatedListMappingJSON {

    const thisField = new FieldMetadataFactory().toJSON(model.ReferencedField_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedField_sys: thisField,
      ReferencedLayoutCombinedRelatedListItem_sys: model.ReferencedLayoutCombinedRelatedListItem_sys
    };
  }

  deepCopy(model: LayoutCombinedRelatedListMappingModel): LayoutCombinedRelatedListMappingModel {

    return new LayoutCombinedRelatedListMappingModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.ReferencedField_sys,
      model.ReferencedLayoutCombinedRelatedListItem_sys
    );
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface LayoutCombinedRelatedListColumnJSON extends BaseJSON {
  SortColumn_sys: boolean;
  SortDirection_sys: SortDirectionType;
  DataType_sys: string;
  ColumnType_sys: string;
  mappings: LayoutCombinedRelatedListMappingJSON[];
}

export class LayoutCombinedRelatedListColumnModel extends BaseModel {

  SortColumn_sys: boolean;
  SortDirection_sys: SortDirectionType;
  DataType_sys: string;
  ColumnType_sys: string;
  mappings: LayoutCombinedRelatedListMappingModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    SortColumn_sys: boolean,
    SortDirection_sys: SortDirectionType,
    DataType_sys: string,
    ColumnType_sys: string,
    mappings: LayoutCombinedRelatedListMappingModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.SortColumn_sys = SortColumn_sys;
    this.SortDirection_sys = SortDirection_sys;
    this.DataType_sys = DataType_sys;
    this.ColumnType_sys = ColumnType_sys;
    this.mappings = mappings;

  }
}

export class LayoutCombinedRelatedListColumnFactory {

  fromJSON(json: LayoutCombinedRelatedListColumnJSON): LayoutCombinedRelatedListColumnModel {

    const mappingFactory = new LayoutCombinedRelatedListMappingFactory();
    const mappings = json.mappings.map((thisMapping: LayoutCombinedRelatedListMappingJSON) => mappingFactory.fromJSON(thisMapping))

    return new LayoutCombinedRelatedListColumnModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.SortColumn_sys,
      json.SortDirection_sys,
      json.DataType_sys,
      json.ColumnType_sys,
      mappings
    );
  }

  toJSON(model: LayoutCombinedRelatedListColumnModel): LayoutCombinedRelatedListColumnJSON {

    const mappingFactory = new LayoutCombinedRelatedListMappingFactory();
    const mappings = model.mappings.map((thisMapping: LayoutCombinedRelatedListMappingModel) => mappingFactory.toJSON(thisMapping))

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      SortColumn_sys: model.SortColumn_sys,
      SortDirection_sys: model.SortDirection_sys,
      DataType_sys: model.DataType_sys,
      ColumnType_sys: model.ColumnType_sys,
      mappings: mappings
    };
  }

  deepCopy(model: LayoutCombinedRelatedListColumnModel): LayoutCombinedRelatedListColumnModel {

    const mappingFactory = new LayoutCombinedRelatedListMappingFactory();
    const mappings = model.mappings.map((thisMapping: LayoutCombinedRelatedListMappingModel) => mappingFactory.deepCopy(thisMapping))

    return new LayoutCombinedRelatedListColumnModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.SortColumn_sys,
      model.SortDirection_sys,
      model.DataType_sys,
      model.ColumnType_sys,
      mappings
    );
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface LayoutCombinedRelatedListSectionJSON extends BaseJSON {
  Rank_sys: number;
  fields: LayoutFieldJSON[];
}

export class LayoutCombinedRelatedListSectionModel extends BaseModel {

  Rank_sys: number;
  fields: LayoutFieldModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Rank_sys: number,
    fields: LayoutFieldModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Rank_sys = Rank_sys;
    this.fields = fields;

  }
}

export class LayoutCombinedRelatedListSectionFactory {

  fromJSON(json: LayoutCombinedRelatedListSectionJSON): LayoutCombinedRelatedListSectionModel {

    const fieldFactory = new LayoutFieldFactory();
    const fields = json.fields.map((thisField: LayoutFieldJSON) => fieldFactory.fromJSON(thisField))

    return new LayoutCombinedRelatedListSectionModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Rank_sys,
      fields
    );
  }

  toJSON(model: LayoutCombinedRelatedListSectionModel): LayoutCombinedRelatedListSectionJSON {

    const fieldFactory = new LayoutFieldFactory();
    const fields = model.fields.map((thisField: LayoutFieldModel) => fieldFactory.toJSON(thisField))

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Rank_sys: model.Rank_sys,
      fields: fields
    };
  }

  deepCopy(model: LayoutCombinedRelatedListSectionModel): LayoutCombinedRelatedListSectionModel {

    const fieldFactory = new LayoutFieldFactory();
    const fields = model.fields.map((thisField: LayoutFieldModel) => fieldFactory.deepCopy(thisField))

    return new LayoutCombinedRelatedListSectionModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.Rank_sys,
      fields
    );
  }
}

//************************************************//
//************************************************//
//************************************************//



export interface LayoutCombinedRelatedListItemJSON extends BaseJSON {
  AccessSetting_sys: string;
  sections: LayoutCombinedRelatedListSectionJSON[];
}

export class LayoutCombinedRelatedListItemModel extends BaseModel {

  AccessSetting_sys: string;
  sections: LayoutCombinedRelatedListSectionModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    AccessSetting_sys: string,
    sections: LayoutCombinedRelatedListSectionModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.AccessSetting_sys = AccessSetting_sys;
    this.sections = sections;

  }
}

export class LayoutCombinedRelatedListItemFactory {

  fromJSON(json: LayoutCombinedRelatedListItemJSON): LayoutCombinedRelatedListItemModel {

    const sectionFactory = new LayoutCombinedRelatedListSectionFactory();
    const sections = json.sections.map((thisSection: LayoutCombinedRelatedListSectionJSON) => sectionFactory.fromJSON(thisSection))

    return new LayoutCombinedRelatedListItemModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.AccessSetting_sys,
      sections
    );
  }

  toJSON(model: LayoutCombinedRelatedListItemModel): LayoutCombinedRelatedListItemJSON {

    const sectionFactory = new LayoutCombinedRelatedListSectionFactory();
    const sections = model.sections.map((thisSection: LayoutCombinedRelatedListSectionModel) => sectionFactory.toJSON(thisSection))

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      AccessSetting_sys: model.AccessSetting_sys,
      sections: sections
    };
  }

  deepCopy(model: LayoutCombinedRelatedListItemModel): LayoutCombinedRelatedListItemModel {

    const sectionFactory = new LayoutCombinedRelatedListSectionFactory();
    const sections = model.sections.map((thisSection: LayoutCombinedRelatedListSectionModel) => sectionFactory.deepCopy(thisSection))

    return new LayoutCombinedRelatedListItemModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.AccessSetting_sys,
      sections
    );
  }
}

//************************************************//
//************************************************//
//************************************************//


export interface LayoutCombinedRelatedListJSON extends BaseJSON {
  columns: LayoutCombinedRelatedListColumnJSON[];
  lists: LayoutCombinedRelatedListItemJSON[];
}

export class LayoutCombinedRelatedListModel extends BaseModel {

  columns: LayoutCombinedRelatedListColumnModel[];
  lists: LayoutCombinedRelatedListItemModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    columns: LayoutCombinedRelatedListColumnModel[],
    lists: LayoutCombinedRelatedListItemModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.columns = columns;
    this.lists = lists;
  }
}

export class LayoutCombinedRelatedListFactory {

  fromJSON(json: LayoutCombinedRelatedListJSON): LayoutCombinedRelatedListModel {

    let columns : LayoutCombinedRelatedListColumnModel[] = [];
    if(json.columns !== undefined){
      columns = json.columns.map((column) => new LayoutCombinedRelatedListColumnFactory().fromJSON(column))
    }
    const lists = json.lists.map((list) => new LayoutCombinedRelatedListItemFactory().fromJSON(list));

    return new LayoutCombinedRelatedListModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      columns,
      lists
    );
  }

  toJSON(model: LayoutCombinedRelatedListModel): LayoutCombinedRelatedListJSON {
    const columns = model.columns.map((column) => new LayoutCombinedRelatedListColumnFactory().toJSON(column))
    const lists = model.lists.map((list) => new LayoutCombinedRelatedListItemFactory().toJSON(list));


    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      columns: columns,
      lists: lists
    };
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface LayoutSectionJSON extends BaseJSON {
  Rank_sys: number;
  DetailHeading_sys: boolean;
  EditHeading_sys: boolean;
  layout_fields: LayoutFieldJSON[];
  layout_related_lists: LayoutRelatedListJSON[];
  layout_combined_related_lists: LayoutCombinedRelatedListJSON[];
}

export class LayoutSectionModel extends BaseModel {
  Rank_sys: number;
  DetailHeading_sys: boolean;
  EditHeading_sys: boolean;
  layout_fields: LayoutFieldModel[];
  layout_related_lists: LayoutRelatedListModel[];
  layout_combined_related_lists: LayoutCombinedRelatedListModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Rank_sys: number,
    DetailHeading_sys: boolean,
    EditHeading_sys: boolean,
    layout_fields: LayoutFieldModel[],
    layout_related_lists: LayoutRelatedListModel[],
    layout_combined_related_lists: LayoutCombinedRelatedListModel[]
  ) {

    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Rank_sys = Rank_sys;
    this.DetailHeading_sys = DetailHeading_sys;
    this.EditHeading_sys = EditHeading_sys;
    this.layout_fields = layout_fields;
    this.layout_related_lists = layout_related_lists;
    this.layout_combined_related_lists = layout_combined_related_lists;
  }
}

export class LayoutSectionFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutSectionJSON): LayoutSectionModel {

    const layout_fields = json.layout_fields.map((layout_field) => new LayoutFieldFactory().fromJSON(layout_field))
                                            .sort((a: LayoutFieldModel, b: LayoutFieldModel) => {
                                              const ncols = 2 //number of cols hardcoded here
                                              const indx1dA = a.PositionX_sys + ncols * a.PositionY_sys
                                              const indx1dB = b.PositionX_sys + ncols * b.PositionY_sys
                                              if(indx1dA > indx1dB) return 1;
                                              if(indx1dA < indx1dB) return -1;
                                              return 0

                                            })
    const layout_related_lists = json.layout_related_lists.map((layout_related_list) => new LayoutRelatedListFactory().fromJSON(layout_related_list));
    const layout_combined_related_lists = json.layout_combined_related_lists.map((this_list) => new LayoutCombinedRelatedListFactory().fromJSON(this_list));

    return new LayoutSectionModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Rank_sys,
      json.DetailHeading_sys,
      json.EditHeading_sys,
      layout_fields,
      layout_related_lists,
      layout_combined_related_lists
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutSectionModel): LayoutSectionJSON {
    const layout_fields = model.layout_fields.map((layout_field) => new LayoutFieldFactory().toJSON(layout_field));
    const layout_related_lists = model.layout_related_lists.map((layout_related_list) => new LayoutRelatedListFactory().toJSON(layout_related_list));
    const layout_combined_related_lists = model.layout_combined_related_lists.map((this_list) => new LayoutCombinedRelatedListFactory().toJSON(this_list));

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Rank_sys: model.Rank_sys,
      DetailHeading_sys: model.DetailHeading_sys,
      EditHeading_sys: model.EditHeading_sys,
      layout_fields: layout_fields,
      layout_related_lists: layout_related_lists,
      layout_combined_related_lists: layout_combined_related_lists
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface LayoutTabJSON extends BaseJSON {
  Rank_sys: number;
  layout_sections: LayoutSectionJSON[];
}

export class LayoutTabModel extends BaseModel {
  Rank_sys: number;
  layout_sections: LayoutSectionModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Rank_sys: number,
    layout_sections: LayoutSectionModel[]
  ) {

    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Rank_sys = Rank_sys;
    this.layout_sections = layout_sections;
  }
}

export class LayoutTabFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutTabJSON): LayoutTabModel {

//    const layout_sections = json.layout_sections.map((layout_section) => new LayoutSectionFactory().fromJSON(layout_section));
    const layout_sections = json.layout_sections.map((layout_section) => new LayoutSectionFactory().fromJSON(layout_section))
                                                .sort((a: LayoutSectionModel, b: LayoutSectionModel) => {
                                                  if(a.Rank_sys > b.Rank_sys) return 1
                                                  if(a.Rank_sys < b.Rank_sys) return -1
                                                  return 0
                                                })

    return new LayoutTabModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Rank_sys,
      layout_sections
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutTabModel): LayoutTabJSON {
    const layout_sections = model.layout_sections.map((layout_section) => new LayoutSectionFactory().toJSON(layout_section));

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Rank_sys: model.Rank_sys,
      layout_sections: layout_sections
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface LayoutJSON extends BaseJSON {
  layout_tabs: LayoutTabJSON[];
}

export class LayoutModel extends BaseModel {
  layout_tabs: LayoutTabModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    layout_tabs: LayoutTabModel[]
  ) {

    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.layout_tabs = layout_tabs;
  }
}

export class LayoutFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: LayoutJSON): LayoutModel {

    let layout_tabs : LayoutTabModel[] = [];
    if(json.layout_tabs !== undefined){
      layout_tabs = json.layout_tabs.map((layout_tab) => new LayoutTabFactory().fromJSON(layout_tab))
                                    .sort((a: LayoutTabModel, b: LayoutTabModel) => {
                                      if(a.Rank_sys > b.Rank_sys) return 1
                                      if(a.Rank_sys < b.Rank_sys) return -1
                                      return 0
                                    })
                                  }

    return new LayoutModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      layout_tabs
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: LayoutModel): LayoutJSON {
    const layout_tabs = model.layout_tabs.map((layout_tab) => new LayoutTabFactory().toJSON(layout_tab));

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      layout_tabs: layout_tabs
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface ListViewColumnJSON extends BaseJSON {
  ReferencedField_sys: FieldMetadataJSON;
}

export class ListViewColumnModel extends BaseModel {

  ReferencedField_sys: FieldMetadataModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedField_sys: FieldMetadataModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedField_sys = ReferencedField_sys;
  }
  clone(): ListViewColumnModel {
    return new ListViewColumnModel(
      this.Id_sys,
      this.Uuid_sys,
      this.ApiName_sys,
      this.Label_sys,
      this.ReferencedField_sys
    )
  }
}

export class ListViewColumnFactory {

  fromJSON(json: ListViewColumnJSON): ListViewColumnModel {

    const ReferencedField_sys = new FieldMetadataFactory().fromJSON(json.ReferencedField_sys);

    return new ListViewColumnModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      ReferencedField_sys
    );
  }
  toJSON(model: ListViewColumnModel): ListViewColumnJSON {
    const ReferencedField_sys = new FieldMetadataFactory().toJSON(model.ReferencedField_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedField_sys: ReferencedField_sys
    };
  }
  deepCopy(model: ListViewColumnModel): ListViewColumnModel {

    const ReferencedField_sys = new FieldMetadataFactory().deepCopy(model.ReferencedField_sys);

    return new ListViewColumnModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      ReferencedField_sys
    );
  }
  toSortOrder(column: ListViewColumnModel,
              rank: number,
              sortDirection: SortDirectionType): SortOrderModel {
    return new SortOrderModel(
        rank,
        sortDirection,
        column.Uuid_sys,
        column.ReferencedField_sys.ApiName_sys
    )
  }
  toBarChartGroup(column: ListViewColumnModel,
                  rank: number = 1,
                  width: string = 'default',
                  hexColour: string = 'default'
                ): BarChartUIPreferenceModel {
    return new BarChartUIPreferenceModel(
        rank,
        width,
        hexColour,
        column.Uuid_sys
    )
  }
}


//************************************************//
//************************************************//
//************************************************//

export interface ViaElementFilterJSON {
  rank: number,
  selected_field: FieldMetadataJSON,
  available_fields: FieldMetadataJSON[]
}
export class ViaElementFilterModel {
  rank: number;
  selectedField: FieldMetadataModel;
  availableFields: FieldMetadataModel[];
  constructor(
    rank: number,
    selectedField: FieldMetadataModel,
    availableFields: FieldMetadataModel[]
  ) {
    this.rank = rank;
    this.selectedField = selectedField;
    this.availableFields = availableFields;
  }
}
export class ViaElementFilterFactory {
  fromJSON(json: ViaElementFilterJSON): ViaElementFilterModel {
    const fieldFactory = new FieldMetadataFactory()
    const selectedField = fieldFactory.fromJSON(json.selected_field);
    const availableFields = json.available_fields.map((thisField: FieldMetadataJSON) => fieldFactory.fromJSON(thisField));

    return new ViaElementFilterModel(
      json.rank,
      selectedField,
      availableFields
    );
  }
  toJSON(model: ViaElementFilterModel): ViaElementFilterJSON {
    const fieldFactory = new FieldMetadataFactory()
    const selectedField = fieldFactory.toJSON(model.selectedField);
    const availableFields = model.availableFields.map((thisField: FieldMetadataModel) => fieldFactory.toJSON(thisField));

    return {
      rank: model.rank,
      selected_field: selectedField,
      available_fields: availableFields
    };
  }
  deepCopy(model: ViaElementFilterModel): ViaElementFilterModel {
    const fieldFactory = new FieldMetadataFactory()
    const selectedField = fieldFactory.deepCopy(model.selectedField);
    const availableFields = model.availableFields.map((thisField: FieldMetadataModel) => fieldFactory.deepCopy(thisField));

    return new ViaElementFilterModel(
      model.rank,
      selectedField,
      availableFields
    );
  }
}

type FilterComparisonSettingType = 'eq' | 'neq' | 'geq' | 'leq' | 'gt' | 'lt' | 'cont' | 'ncont' | 'in' | 'nin'

export interface ListViewFilterJSON extends BaseJSON {
  Rank_sys: number,
  ComparisonSetting_sys: FilterComparisonSettingType,
  Value_sys: string,
  ReferencedField_sys: FieldMetadataJSON,
  via_elements: ViaElementFilterJSON[]
}

export class ListViewFilterModel extends BaseModel {

  Rank_sys: number;
  ComparisonSetting_sys: FilterComparisonSettingType;
  Value_sys: string;
  ReferencedField_sys: FieldMetadataModel;
  viaElements: ViaElementFilterModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Rank_sys: number,
    ComparisonSetting_sys: FilterComparisonSettingType,
    Value_sys: string,
    ReferencedField_sys: FieldMetadataModel,
    viaElements: ViaElementFilterModel[],
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.Rank_sys = Rank_sys;
    this.ComparisonSetting_sys = ComparisonSetting_sys;
    this.Value_sys = Value_sys;
    this.ReferencedField_sys = ReferencedField_sys;
    this.viaElements = viaElements;
  }
}

export class ListViewFilterFactory {

  fromJSON(json: ListViewFilterJSON): ListViewFilterModel {

    const fieldFactory = new FieldMetadataFactory()
    const viaElementFactory = new ViaElementFilterFactory()
    const ReferencedField_sys = fieldFactory.fromJSON(json.ReferencedField_sys);
    const viaElements = json.via_elements.map((thisViaField: ViaElementFilterJSON) => viaElementFactory.fromJSON(thisViaField))
                                         .sort((a: ViaElementFilterModel, b: ViaElementFilterModel) => {
                                           if(a.rank > b.rank) return 1
                                           if(a.rank < b.rank) return -1
                                           return 0
                                         });
    return new ListViewFilterModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Rank_sys,
      json.ComparisonSetting_sys,
      json.Value_sys,
      ReferencedField_sys,
      viaElements
    );
  }

  toJSON(model: ListViewFilterModel): ListViewFilterJSON {
    const fieldFactory = new FieldMetadataFactory()
    const viaElementFactory = new ViaElementFilterFactory()
    const ReferencedField_sys = fieldFactory.toJSON(model.ReferencedField_sys);
    const viaElements = model.viaElements.map((thisViaField: ViaElementFilterModel) => viaElementFactory.toJSON(thisViaField));

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Rank_sys: model.Rank_sys,
      ComparisonSetting_sys: model.ComparisonSetting_sys,
      Value_sys: model.Value_sys,
      ReferencedField_sys: ReferencedField_sys,
      via_elements: viaElements
    };
  }


  deepCopy(model: ListViewFilterModel): ListViewFilterModel {
    const fieldFactory = new FieldMetadataFactory()
    const viaElementFactory = new ViaElementFilterFactory()
    const ReferencedField_sys = fieldFactory.deepCopy(model.ReferencedField_sys);
    const viaElements = model.viaElements.map((thisViaField: ViaElementFilterModel) => viaElementFactory.deepCopy(thisViaField));

    return new ListViewFilterModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.Rank_sys,
      model.ComparisonSetting_sys,
      model.Value_sys,
      ReferencedField_sys,
      viaElements
    );
  }
}

//************************************************//
//************************************************//
//************************************************//


export interface ListViewJSON extends BaseJSON {
  FilterLogic_sys: string;
  listview_columns: ListViewColumnJSON[];
  listview_filters: ListViewFilterJSON[];
  user_preference: ListViewUIPreferenceJSON | null;
}

export class ListViewModel extends BaseModel {

  FilterLogic_sys: string;
  listview_columns: ListViewColumnModel[];
  listview_filters: ListViewFilterModel[];
  user_preference: ListViewUIPreferenceModel | null;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    FilterLogic_sys: string,
    listview_columns: ListViewColumnModel[],
    listview_filters: ListViewFilterModel[],
    user_preference: ListViewUIPreferenceModel | null
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.FilterLogic_sys = FilterLogic_sys;
    this.listview_columns = listview_columns;
    this.listview_filters = listview_filters;
    this.user_preference = user_preference;
  }

  getDisplayType(): string {
    if(this.user_preference &&
       this.user_preference.DisplayType_sys){
         return this.user_preference.DisplayType_sys
       }
    //default:
    return 'List'
  }

  clone(): ListViewModel {
    const listViewColumns = this.listview_columns.map((thisListViewColumn: ListViewColumnModel) => thisListViewColumn.clone())
    let user_preference = null
    if(this.user_preference){
      user_preference = this.user_preference.clone()
    }
    return new ListViewModel(
      this.Id_sys,
      this.Uuid_sys,
      this.ApiName_sys,
      this.Label_sys,
      this.FilterLogic_sys,
      listViewColumns,
      this.listview_filters,
      user_preference
    )
  }

}

export class ListViewFactory {
  /**
   *
   * @param json
   */


  fromJSON(json: ListViewJSON): ListViewModel {

    let listview_columns : ListViewColumnModel[] = [];
    if(json.listview_columns !== undefined){
      listview_columns = json.listview_columns.map((column) => new ListViewColumnFactory().fromJSON(column))
    }

    let listview_filters : ListViewFilterModel[] = [];
    if(json.listview_filters !== undefined){
      listview_filters = json.listview_filters.map((filter) => new ListViewFilterFactory().fromJSON(filter))
    }

    let user_preference=null
    if(json.user_preference){
      user_preference = new ListViewUIPreferenceFactory().fromJSON(json.user_preference)
    }

    return new ListViewModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.FilterLogic_sys,
      listview_columns,
      listview_filters,
      user_preference
    );
  }
  /**
   *
   * @param model
   */

  toJSON(model: ListViewModel): ListViewJSON {
    const listview_columns = model.listview_columns.map((column) => new ListViewColumnFactory().toJSON(column))
    const listview_filters = model.listview_filters.map((filter) => new ListViewFilterFactory().toJSON(filter))
    let user_preference=null
    if(model.user_preference){
      user_preference = new ListViewUIPreferenceFactory().toJSON(model.user_preference)
    }

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      FilterLogic_sys: model.FilterLogic_sys,
      listview_columns: listview_columns,
      listview_filters: listview_filters,
      user_preference: user_preference
    };
  }
}

//************************************************//
//************************************************//
//************************************************//


export interface RecordTypeJSON extends BaseJSON {
  DefaultLayout_sys: LayoutJSON;
}

export class RecordTypeModel extends BaseModel {

  DefaultLayout_sys: LayoutModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    DefaultLayout_sys: LayoutModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.DefaultLayout_sys = DefaultLayout_sys;
  }
}

export class RecordTypeFactory {
  /**
   *
   * @param json
   */


  fromJSON(json: RecordTypeJSON): RecordTypeModel {

    const default_layout = new LayoutFactory().fromJSON(json.DefaultLayout_sys);

    return new RecordTypeModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      default_layout
    );
  }
  /**
   *
   * @param model
   */

  toJSON(model: RecordTypeModel): RecordTypeJSON {

    const default_layout = new LayoutFactory().toJSON(model.DefaultLayout_sys);

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      DefaultLayout_sys: default_layout
    };
  }
}
//************************************************//
//************************************************//
//************************************************//

export interface ApplicationJSON extends BaseJSON {
  Description_sys: string;
  ReferencedIcon_sys: IconJSON | null;
  user_preference: ApplicationUIPreferenceJSON | null;
}

export class ApplicationModel extends BaseModel {
  Description_sys: string;
  ReferencedIcon_sys: IconModel | null;
  user_preference: ApplicationUIPreferenceModel | null;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Description_sys: string,
    ReferencedIcon_sys: IconModel | null,
    user_preference: ApplicationUIPreferenceModel | null
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);
    this.Description_sys = Description_sys;
    this.ReferencedIcon_sys = ReferencedIcon_sys;
    this.user_preference = user_preference;
  }
}


export class ApplicationFactory {

  fromJSON(json: ApplicationJSON): ApplicationModel {
    let user_preference=null
    if(json.user_preference){
      user_preference = new ApplicationUIPreferenceFactory().fromJSON(json.user_preference)
    }
    let thisIcon = null
    if(json.ReferencedIcon_sys) thisIcon = new IconFactory().fromJSON(json.ReferencedIcon_sys)

    return new ApplicationModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Description_sys,
      thisIcon,
      user_preference
    );
  }

  toJSON(model: ApplicationModel): ApplicationJSON {
    let user_preference=null
    if(model.user_preference) user_preference = new ApplicationUIPreferenceFactory().toJSON(model.user_preference)
    let thisIcon = null
    if(model.ReferencedIcon_sys) thisIcon = new IconFactory().toJSON(model.ReferencedIcon_sys)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Description_sys: model.Description_sys,
      ReferencedIcon_sys: thisIcon,
      user_preference: user_preference
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface ObjectJSON extends BaseJSON {
  PluralLabel_sys: string;
  ReferencedIcon_sys: IconModel | null;
  HexColour_sys: string;
}

export class ObjectModel extends BaseModel {

  PluralLabel_sys: string;
  ReferencedIcon_sys: IconModel | null;
  HexColour_sys: string;

  constructor(
    Id_sys: string = '',
    Uuid_sys: string = '',
    ApiName_sys: string = '',
    Label_sys: string = '',
    PluralLabel_sys: string = '',
    ReferencedIcon_sys: IconModel | null = null,
    Colour_sys: string = '#D6D6D6',
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.PluralLabel_sys = PluralLabel_sys;
    this.ReferencedIcon_sys = ReferencedIcon_sys;
    this.HexColour_sys = Colour_sys;

  }
}


export class ObjectFactory {
  fromJSON(json: ObjectJSON): ObjectModel {
    let thisIcon = null
    if(json.ReferencedIcon_sys) thisIcon = new IconFactory().fromJSON(json.ReferencedIcon_sys)

    return new ObjectModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.PluralLabel_sys,
      thisIcon,
      json.HexColour_sys
    );
  }
  toJSON(model: ObjectModel): ObjectJSON {
    let thisIcon = null
    if(model.ReferencedIcon_sys) thisIcon = new IconFactory().toJSON(model.ReferencedIcon_sys)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      PluralLabel_sys: model.PluralLabel_sys,
      ReferencedIcon_sys: thisIcon,
      HexColour_sys: model.HexColour_sys
    };
  }

  deepCopy(model: ObjectModel): ObjectModel {
    let thisIcon = null
    if(model.ReferencedIcon_sys) thisIcon = new IconFactory().deepcopy(model.ReferencedIcon_sys)
    return new ObjectModel(
      model.Id_sys,
      model.Uuid_sys,
      model.ApiName_sys,
      model.Label_sys,
      model.PluralLabel_sys,
      thisIcon,
      model.HexColour_sys
    );
  }



}


//************************************************//
//************************************************//
//************************************************//

export interface ObjectPageButtonJSON extends BaseJSON {
  action: ActionJSON;
}

export class ObjectPageButtonModel extends BaseModel {

  action: ActionModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    action: ActionModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.action = action;

  }
}

export class ObjectPageButtonFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: ObjectPageButtonJSON): ObjectPageButtonModel {
    const thisAction = new ActionFactory().fromJSON(json.action)
    return new ObjectPageButtonModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      thisAction
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: ObjectPageButtonModel): ObjectPageButtonJSON {
    const thisAction = new ActionFactory().toJSON(model.action)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      action: thisAction
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface ObjectPageJSON extends BaseJSON {
  objectpage_buttons: ObjectPageButtonJSON[];
}

export class ObjectPageModel extends BaseModel {

  objectpage_buttons: ObjectPageButtonModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    objectpage_buttons: ObjectPageButtonModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.objectpage_buttons = objectpage_buttons;

  }
}

export class ObjectPageFactory {
  /**
   *
   * @param json
   */
  fromJSON(json: ObjectPageJSON): ObjectPageModel {
    const thisButtons = json.objectpage_buttons.map((thisButton) => new ObjectPageButtonFactory().fromJSON(thisButton))
    return new ObjectPageModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      thisButtons
    );
  }
  /**
   *
   * @param model
   */
  toJSON(model: ObjectPageModel): ObjectPageJSON {
    const thisButtons = model.objectpage_buttons.map((thisButton) => new ObjectPageButtonFactory().toJSON(thisButton))
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      objectpage_buttons: thisButtons
    };
  }
}



//************************************************//
//************************************************//
//************************************************//

export interface TabJSON extends BaseJSON {
  ReferencedObject_sys: ObjectJSON;
  user_preference: TabUIPreferenceJSON | null;
}

export class TabModel extends BaseModel {

  ReferencedObject_sys: ObjectModel;
  user_preference: TabUIPreferenceModel | null;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    ReferencedObject_sys: ObjectModel,
    user_preference: TabUIPreferenceModel | null
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);

    this.ReferencedObject_sys = ReferencedObject_sys;
    this.user_preference = user_preference;

  }
}


export class TabFactory {

  fromJSON(json: TabJSON): TabModel {

    const ReferencedObject_sys = new ObjectFactory().fromJSON(json.ReferencedObject_sys);
    let user_preference=null
    if(json.user_preference){
      user_preference = new TabUIPreferenceFactory().fromJSON(json.user_preference)
    }

    return new TabModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      "",
      ReferencedObject_sys,
      user_preference
    );
  }

  toJSON(model: TabModel): TabJSON {

    const ReferencedObject_sys = new ObjectFactory().toJSON(model.ReferencedObject_sys);
    let user_preference=null
    if(model.user_preference){
      user_preference = new TabUIPreferenceFactory().toJSON(model.user_preference)
    }


    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      ReferencedObject_sys: ReferencedObject_sys,
      user_preference: user_preference
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

//NOTE: NOT YET IMPLEMENTED IN BACKEND
//ONLY FOR SEARCH PAGE IN FRONTEND

export interface CustomPageJSON extends BaseJSON {
}

export class CustomPageModel extends BaseModel {

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);
  }
}

//************************************************//
//************************************************//
//************************************************//

/************************************************/
/************************************************/
/************************************************/

export type ApplicationPageElementTypeJSON = DashboardScreenElementJSON |
                                             SearchScreenElementJSON
export type ApplicationPageElementTypeModel = DashboardScreenElementModel |
                                              SearchScreenElementModel

export class ApplicationPageElementFactory {
  fromJSON(json: ApplicationPageElementTypeJSON): ApplicationPageElementTypeModel {
    switch(json.Type_sys){
      case 'Chart':
        return new DashboardScreenElementFactory().fromJSON(json as DashboardScreenElementJSON)
      case 'Search':
        return new SearchScreenElementFactory().fromJSON(json as SearchScreenElementJSON)
      default:
        throw new Error(`Unsupported component type: ${JSON.stringify(json)}`)
    }
  }

  toJSON(model: ApplicationPageElementTypeModel): ApplicationPageElementTypeJSON {
    switch(model.Type_sys){
      case 'Chart':
        return new DashboardScreenElementFactory().toJSON(model as DashboardScreenElementModel)
      case 'Search':
        return new SearchScreenElementFactory().toJSON(model as SearchScreenElementModel)
      default:
        throw new Error(`Unsupported component type: ${model}`)
    }
  }
}

export interface ApplicationPageJSON extends BaseJSON{
  Rank_sys: number;
  page_elements: ApplicationPageElementTypeJSON[];
}

export class ApplicationPageModel extends BaseModel {
  Rank_sys: number;
  pageElements: ApplicationPageElementTypeModel[];

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Rank_sys: number,
    pageElements: ApplicationPageElementTypeModel[]
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys);
    this.Rank_sys = Rank_sys;
    this.pageElements = pageElements;
  }
}


export class ApplicationPageFactory {
  fromJSON(json: ApplicationPageJSON): ApplicationPageModel {
    const pageElementFactory = new ApplicationPageElementFactory()
    const pageElements = json.page_elements.map((thisElement: ApplicationPageElementTypeJSON) => pageElementFactory.fromJSON(thisElement));
    return new ApplicationPageModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Rank_sys,
      pageElements
    );
  }
  toJSON(model: ApplicationPageModel): ApplicationPageJSON {
    const pageElementFactory = new ApplicationPageElementFactory()
    const pageElements = model.pageElements.map((thisElement: ApplicationPageElementTypeModel) => pageElementFactory.toJSON(thisElement));
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Rank_sys: model.Rank_sys,
      page_elements: pageElements
    };
  }
}

//************************************************//
//************************************************//
//************************************************//

export interface EmailUserJSON {
  Id_sys: string;
  Uuid_sys: string;
  Email_c: string;
}

export class EmailUserModel {
  Id_sys: string;
  Uuid_sys: string;
  Email_c: string;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    Email_c: string
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.Email_c = Email_c;
  }

  deepCopy(): EmailUserModel {
    return new EmailUserModel(this.Id_sys, this.Uuid_sys, this.Email_c)
  }
}

export class EmailUserFactory {

  fromJSON(json: EmailUserJSON): EmailUserModel {
    return new EmailUserModel(
      json.Id_sys,
      json.Uuid_sys,
      json.Email_c
    )
  }

  toJSON(model: EmailUserModel): EmailUserJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      Email_c: model.Email_c
    }
  }
}

/**********************************************/

export interface EmailConnectorJSON {
  Id_sys: string;
  Uuid_sys: string;
  ReferencedUser_c: EmailUserJSON;
}

export class EmailConnectorModel {

  Id_sys: string;
  Uuid_sys: string;
  ReferencedUser_c: EmailUserModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ReferencedUser_c: EmailUserModel
  ) {

    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.ReferencedUser_c = ReferencedUser_c;
  }

  deepCopy(): EmailConnectorModel {
    return new EmailConnectorModel(this.Id_sys, this.Uuid_sys, this.ReferencedUser_c.deepCopy())
  }
}

export class EmailConnectorFactory {

  fromJSON(json: EmailConnectorJSON): EmailConnectorModel {
    const referencedUser = new EmailUserFactory().fromJSON(json.ReferencedUser_c)
    return new EmailConnectorModel(
      json.Id_sys,
      json.Uuid_sys,
      referencedUser
    );
  }

  toJSON(model: EmailConnectorModel): EmailConnectorJSON {
    const thisUser = new EmailUserFactory().toJSON(model.ReferencedUser_c)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ReferencedUser_c: thisUser
    }
  }

}


/**********************************************/

export interface EmailContextRecordJSON {
  Id_sys: number;
  Uuid_sys: string;
  lookup_display_value: string;
  referenced_object: ObjectJSON;
}

export class EmailContextRecordModel {
  Id_sys: number;
  Uuid_sys: string;
  lookupDisplayValue: string;
  referencedObject: ObjectModel | null;

  constructor(
    Id_sys: number = -1,
    Uuid_sys: string = "",
    lookupDisplayValue: string = "",
    referencedObject: ObjectModel | null = null
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.lookupDisplayValue = lookupDisplayValue;
    this.referencedObject = referencedObject
  }

  fromJSON(json: any): EmailContextRecordModel {
    const thisRecord = new EmailContextRecordModel()
    if(json.Id_sys) thisRecord.Id_sys = json.Id_sys
    if(json.Uuid_sys) thisRecord.Uuid_sys = json.Uuid_sys
    if(json.lookup_display_value) thisRecord.lookupDisplayValue = json.lookup_display_value
    if(json.referenced_object) thisRecord.referencedObject = new ObjectFactory().fromJSON(json.referenced_object)

    return thisRecord
  }

  toJSON(): any {
    return {Id_sys: this.Id_sys,
            Uuid_sys: this.Uuid_sys,
            lookup_display_value: this.lookupDisplayValue,
            referenced_object: this.referencedObject}
  }

  deepCopy(): EmailContextRecordModel {
    const referencedObject = this.referencedObject ? new ObjectFactory().deepCopy(this.referencedObject) : null;
    return new EmailContextRecordModel(this.Id_sys,
                                       this.Uuid_sys,
                                       this.lookupDisplayValue,
                                       referencedObject)
  }

}

/**********************************************/

export interface EmailContextObjectJSON {
  Id_sys: number;
  Uuid_sys: string;
  ContextKey_c: string;
  ContextType_c: string;
  ReferencedObject_c: ObjectJSON;
  referencedRecord: EmailContextRecordJSON;
}

export class EmailContextObjectModel {
  Id_sys: number;
  Uuid_sys: string;
  ContextKey_c: string;
  ContextType_c: string;
  ReferencedObject_c: ObjectModel;
  referencedRecord: EmailContextRecordModel;

  constructor(
    Id_sys: number = -1,
    Uuid_sys: string = '',
    ContextKey_c: string = '',
    ContextType_c: string = '',
    ReferencedObject_c: ObjectModel = new ObjectModel(),
    referencedRecord: EmailContextRecordModel = new EmailContextRecordModel()
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.ContextKey_c = ContextKey_c;
    this.ContextType_c = ContextType_c;
    this.ReferencedObject_c = ReferencedObject_c;
    this.referencedRecord = referencedRecord;
  }

  fromJSON(json: any): EmailContextObjectModel {
    const thisObject = new ObjectFactory().fromJSON(json.context_object);
    const thisRecord = new EmailContextRecordModel().fromJSON(json.context_record);

    const thisEmailContextObject = new EmailContextObjectModel(json.Id_sys, json.Uuid_sys, json.ContextKey_c, json.ContextType_c, thisObject, thisRecord);
    return thisEmailContextObject
  }

  toJSON(): any {
    const thisObject = new ObjectFactory().fromJSON(this.ReferencedObject_c);

    return {Id_sys: this.Id_sys,
            Uuid_sys: this.Uuid_sys,
            ContextKey_c: this.ContextKey_c,
            ContextType_c: this.ContextType_c,
            context_object: thisObject,
            context_record: this.referencedRecord.toJSON()}

  }

  setReferencedRecord(thisRecord: RecordModel | EmailContextRecordModel | null) {
    if(thisRecord instanceof RecordModel){
      this.referencedRecord = new EmailContextRecordModel(thisRecord.fields.Id_sys.fieldValue, thisRecord.fields.Uuid_sys.fieldValue, thisRecord.fields.lookup_display_value.fieldValue)
    }
    if(thisRecord instanceof EmailContextRecordModel){
      this.referencedRecord = thisRecord
    }
  }

  deepCopy(): EmailContextObjectModel {
    const thisObject = new ObjectFactory().deepCopy(this.ReferencedObject_c);
    const thisRecord = this.referencedRecord.deepCopy();
    return new EmailContextObjectModel(this.Id_sys,
                                       this.Uuid_sys,
                                       this.ContextKey_c,
                                       this.ContextType_c,
                                       thisObject,
                                       thisRecord)
  }

}

/**********************************************/

export interface EmailTemplateJSON {
  Id_sys: number,
  Uuid_sys: string,
  Label_c: string,
  Subject_c: string,
  HtmlContent_c: string,
  TextContent_c: string,
  context_objects: EmailContextObjectJSON[]
}



export class EmailTemplateModel {
  Id_sys: number;
  Uuid_sys: string;
  Label_c: string;
  Subject_c: string;
  HtmlContent_c: string;
  TextContent_c: string;
  contextObjects: EmailContextObjectModel[];

  constructor(
    Id_sys: number = -1,
    Uuid_sys: string = '',
    Label_c: string = '',
    Subject_c: string = '',
    HtmlContent_c: string = '',
    TextContent_c: string = '',
    contextObjects: EmailContextObjectModel[] = []
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.Label_c = Label_c;
    this.Subject_c = Subject_c;
    this.HtmlContent_c = HtmlContent_c;
    this.TextContent_c = TextContent_c;
    this.contextObjects = contextObjects;
  }

  setContextRecord(thisContextObject: EmailContextObjectModel, thisRecord: RecordModel | EmailContextRecordModel | null): void {
    //set a context record for related email template with given context-object
    //find the correct context object
    const contextObject = this.contextObjects.find((current: EmailContextObjectModel) => current.Uuid_sys === thisContextObject.Uuid_sys)
    if(contextObject){
      contextObject.setReferencedRecord(thisRecord)
    }
  }



}

export class EmailTemplateFactory {
  /**
   * @param json
   */
  fromJSON(json: EmailTemplateJSON): EmailTemplateModel {
    const context_objects = json.context_objects.map((thisJSON) => new EmailContextObjectModel().fromJSON(thisJSON))
    return new EmailTemplateModel(
      json.Id_sys,
      json.Uuid_sys,
      json.Label_c,
      json.Subject_c,
      json.HtmlContent_c,
      json.TextContent_c,
      context_objects
    );
  }

  toJSON(model: EmailTemplateModel): EmailTemplateJSON {
    const context_objects = model.contextObjects.map((thisContextObject: EmailContextObjectModel) => thisContextObject.toJSON())
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      Label_c: model.Label_c,
      Subject_c: model.Subject_c,
      HtmlContent_c: model.HtmlContent_c,
      TextContent_c: model.TextContent_c,
      context_objects: context_objects
    };
  }
}

/**********************************************/

export interface EmailRecipientJSON {
  email: string,
  context_record: EmailContextRecordJSON | null
}

export class EmailRecipientModel {
  email: string;
  contextRecord: EmailContextRecordModel | null;

  constructor(
    email: string = '',
    contextRecord: EmailContextRecordModel | null = null
  ) {
    this.email = email;
    this.contextRecord = contextRecord;
  }

  fromJSON(json: EmailRecipientJSON): EmailRecipientModel {
    const contextRecord = json.context_record ? new EmailContextRecordModel().fromJSON(json.context_record) : null;
    return new EmailRecipientModel(json.email, contextRecord)
  }

  toJSON(): EmailRecipientJSON {
    const contextRecord = this.contextRecord ? this.contextRecord.toJSON() : null;
    return {
      email: this.email,
      context_record: contextRecord
    }
  }

  setFromContext(thisContextObject: EmailContextObjectModel, thisRecord: RecordModel | null){
    if(!thisRecord){
      this.contextRecord = null;
    } else {
      this.contextRecord = new EmailContextRecordModel(thisRecord.fields.Id_sys.fieldValue,
                                                       thisRecord.fields.Uuid_sys.fieldValue,
                                                       thisRecord.fields.lookup_display_value.fieldValue,
                                                       thisContextObject.ReferencedObject_c)
    }
  }

  deepCopy(): EmailRecipientModel {
    const contextRecord = this.contextRecord ? this.contextRecord.deepCopy() : null;
    return new EmailRecipientModel(this.email, contextRecord)
  }

}

/**********************************************/

export interface EmailPreviewJSON {
  sender: EmailConnectorJSON,
  recipient: EmailRecipientJSON,
  subject: string,
  body: string
}

export class EmailPreviewModel {

  sender: EmailConnectorModel;
  recipient: EmailRecipientModel;
  subject: string;
  body: string;

  constructor(
    sender: EmailConnectorModel,
    recipient: EmailRecipientModel,
    subject: string,
    body: string
  ) {

    this.sender = sender;
    this.recipient = recipient;
    this.subject = subject;
    this.body = body;
  }
}

export class EmailPreviewFactory {
  /**
   * @param json
   */
  fromJSON(json: EmailPreviewJSON): EmailPreviewModel {
    const sender = new EmailConnectorFactory().fromJSON(json.sender)
    const recipient = new EmailRecipientModel().fromJSON(json.recipient)
    return new EmailPreviewModel(
      sender,
      recipient,
      json.subject,
      json.body
    );
  }
}

/**********************************************/

export interface EmailMessageJSON {
  sender: EmailConnectorJSON | null,
  recipient: EmailRecipientJSON,
  cc: EmailRecipientJSON[],
  bcc: EmailRecipientJSON[],
  subject: string,
  body: string,
  template: EmailTemplateJSON | null
}


export class EmailMessageModel {
  sender: EmailConnectorModel | null;
  recipient: EmailRecipientModel;
  cc: EmailRecipientModel[];
  bcc: EmailRecipientModel[];
  subject: string;
  body: string;
  template: EmailTemplateModel | null;

  constructor(
    sender: EmailConnectorModel | null = null,
    recipient: EmailRecipientModel = new EmailRecipientModel(),
    cc: EmailRecipientModel[] = [],
    bcc: EmailRecipientModel[] = [],
    subject: string = "",
    body: string = "",
    template: EmailTemplateModel | null = null
  ){
    this.sender = sender;
    this.recipient = recipient;
    this.cc = cc;
    this.bcc = bcc;
    this.subject = subject;
    this.body = body;
    this.template = template;
  }

  toJSON(): EmailMessageJSON {
    const emailConnectorFactory = new EmailConnectorFactory()
    const sender = this.sender ? emailConnectorFactory.fromJSON(this.sender) : null;

    const recipient = this.recipient.toJSON();
    const cc = this.cc.map((thisRecipient: EmailRecipientModel) => thisRecipient.toJSON())
    const bcc = this.bcc.map((thisRecipient: EmailRecipientModel) => thisRecipient.toJSON())

    const emailTemplateFactory = new EmailTemplateFactory()
    const template = this.template ? emailTemplateFactory.toJSON(this.template) : null;

    return {
      sender: sender,
      recipient: recipient,
      cc: cc,
      bcc: bcc,
      subject: this.subject,
      body: this.body,
      template: template
    }

  }

  deepCopy(): EmailMessageModel {
    const sender = this.sender ? this.sender.deepCopy() : null;
    const recipient = this.recipient.deepCopy();
    const cc = this.cc.map((thisRecipient) => thisRecipient.deepCopy());
    const bcc = this.bcc.map((thisRecipient) => thisRecipient.deepCopy());
    const subject = this.subject
    const body = this.body
    //NOTE: email template will not be deepcopied, because
    //other templates will need to use the same reference
    const template = this.template

    return new EmailMessageModel(sender, recipient, cc, bcc, subject, body, template)
  }

  setSender(thisConnector: EmailConnectorModel): void {
    this.sender = thisConnector;
  }
  setRecipient(thisRecipient: EmailRecipientModel): void {
    this.recipient = thisRecipient;
  }
  setSubject(thisSubject: string): void {
    this.subject = thisSubject;
  }
  setBody(thisBody: string): void {
    this.body = thisBody;
  }
  setEmailTemplate(thisTemplate: EmailTemplateModel): void {
    this.template = thisTemplate;
    this.subject = thisTemplate.Subject_c;
    this.body = thisTemplate.HtmlContent_c;
  }
  setContextRecord(thisContextObject: EmailContextObjectModel, thisRecord: RecordModel | EmailContextRecordModel | null): void {
    //set a context record for related email template with given context-object
    if(this.template){
      this.template.setContextRecord(thisContextObject, thisRecord)
    }
  }
  setContextRecipient(thisContextObject: EmailContextObjectModel, thisRecord: RecordModel | null): void {
    //set the recipient from a contextObject and selected record
    this.recipient.setFromContext(thisContextObject, thisRecord)
  }

}
